import { useState } from 'react';
import { MdOutlineDownload } from 'react-icons/md';
import { ImSpinner2 } from 'react-icons/im'; // Spinner icon

interface Props {
  onClick: () => Promise<void>;
}

const DownloadButton = ({ onClick }: Props) => {
  const [downloading, setDownloading] = useState(false);

  const handleClick = async () => {
    setDownloading(true);
    try {
      await onClick();
    } catch (error) {
      console.error('Error in onClick:', error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button
      className="btn btn-sm btn-ghost tooltip tooltip-bottom"
      data-tip="Download"
      onClick={handleClick}
      disabled={downloading}>
      {downloading ? <ImSpinner2 className="animate-spin" size={24} /> : <MdOutlineDownload size={24} />}
    </button>
  );
};

export default DownloadButton;
